import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Container from 'common/Container';
import CloudHostingIllustration from 'svg/illustrations/CloudHosting';
import Link from '@mui/material/Link';
import useMediaQuery from '@mui/material/useMediaQuery';

const CONTACT_PHONE_DISPLAY = '+1 (614) 579-0661';
const CONTACT_PHONE_LINK = 'tel:+16145790661';
const MOBILE_MEDIA_QUERY = '(max-width: 767px)';

const primaryActionSx = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 48,
  paddingX: 3,
  paddingY: 1.5,
  borderRadius: 1,
  backgroundColor: 'primary.main',
  color: 'primary.contrastText',
  fontWeight: 700,
  textDecoration: 'none',
  '&:hover': {
    backgroundColor: 'primary.dark',
    textDecoration: 'none',
  },
};

const secondaryActionSx = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 48,
  paddingX: 3,
  paddingY: 1.5,
  borderRadius: 1,
  border: 1,
  borderColor: 'primary.main',
  color: 'primary.main',
  fontWeight: 700,
  textDecoration: 'none',
  '&:hover': {
    backgroundColor: 'action.hover',
    textDecoration: 'none',
  },
};

const FormSent = () => {
  const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY, {
    defaultMatches: false,
  });

  return (
    <Box
      minHeight={'calc(100vh - 64px - 183px)'}
      height={'100%'}
      display={'flex'}
      alignItems={'center'}
    >
      <Container>
        <Grid container spacing={4}>
          <Grid item container justifyContent={'center'} xs={12}>
            <Box height={'100%'} width={'100%'} maxWidth={500}>
              <CloudHostingIllustration width={'100%'} height={'100%'} />
            </Box>
          </Grid>
          <Grid
            item
            container
            alignItems={'center'}
            justifyContent={'center'}
            xs={12}
          >
            <Box>
              <Typography
                variant="h4"
                component={'h4'}
                align={'center'}
                gutterBottom
                sx={{ fontWeight: 700 }}
              >
                Form Submitted Successfully
              </Typography>
              <Typography component="p" color="textSecondary" align={'center'}>
                Thank you for reaching out. Your form was submitted successfully,
                and you should hear back from us within 1-2 business days. If
                your project is urgent, call us at{' '}
                <Link href={CONTACT_PHONE_LINK} underline="hover">
                  {CONTACT_PHONE_DISPLAY}
                </Link>
                .
              </Typography>
              <Box display={'flex'} justifyContent={'center'} flexWrap={'wrap'} gap={2} marginTop={3}>
                <Link
                  underline={'none'}
                  component={'a'}
                  href="/"
                  sx={primaryActionSx}
                >
                  Back home
                </Link>
                {isMobile ? (
                  <Link
                    underline={'none'}
                    component={'a'}
                    href={CONTACT_PHONE_LINK}
                    sx={secondaryActionSx}
                  >
                    Call us
                  </Link>
                ) : null}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default FormSent;
